;(function ($) {
  var Menu = function (element, options) {
    this.options = options
    this.$element = $(element)

    this.$toggleContainer = this.$element.find(options.toggleContainer)
    this.$toggleButton = this.$element.find(options.toggleButton)
    this.$closeButton = this.$element.find(options.closeButton)

    this.init()
  }

  Menu.defaults = {
    toggleClass: '.toggled',
    toggleContainer: '.toggle-container',
    toggleButton: '.toggle-button',
    closeButton: '.close-button'
  }

  Menu.prototype.init = function () {
    var _this = this
    // Toggle Button
    this.$toggleButton.click(function () {
      _this.$toggleContainer.toggleClass(_this.options.toggleClass)
    })
    // Close Button
    this.$closeButton.click(function () {
      _this.$toggleContainer.removeClass(_this.options.toggleClass)
    })
  }

  $.fn.Menu = function (option) {
    return this.each(function () {
      var $this = $(this)
      var data = $this.data('Menu')
      var options = $.extend(
        {},
        Menu.defaults,
        $this.data(),
        typeof option == 'object' && option
      )
      if (!data) {
        $this.data('Menu', (data = new Menu(this, options)))
      }
    })
  }
})(jQuery)
